import { DateTime } from 'luxon';

export const fromDateString = (date: string) => DateTime.fromFormat(date, 'd MMMM yyyy').valueOf();
